import { Spin } from "antd";
import { LoadingSpinnerProps } from "@/utils/types/loadingSpinner";

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "large",
  fullScreen = true,
  text = "Loading...",
  className = "",
}) => {
  const spinnerContent = (
    <div className="flex flex-col items-center justify-center">
      <Spin size={size} />
      {text && <div className="mt-4 text-sm text-gray-500">{text}</div>}
    </div>
  );

  if (fullScreen) {
    return (
      <div
        className={`flex h-screen items-center justify-center md:h-[calc(100vh-200px)] ${className}`}
      >
        {spinnerContent}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {spinnerContent}
    </div>
  );
};

export default LoadingSpinner;
